import React from 'react';
import { Popover as MuiPopover } from '@mui/material';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import popoverStyle from './Popover.css';

const Popover = ({
    showPopover = false,
    anchorEl = {},
    children,
    header = null,
    wrapperRef = null,
    anchorOrigin,
    transformOrigin,
    className = '',
    rootClassName,
    PaperProps,
    disableScrollLock = false,
    hideBackdrop = false,
    transitionDuration,
    onClose,
}) => {
    return (
        <MuiPopover
            open={showPopover}
            anchorEl={anchorEl}
            onClose={onClose}
            className={rootClassName}
            anchorOrigin={
                anchorOrigin || {
                    vertical: 'top',
                    horizontal: 'right',
                }
            }
            transformOrigin={
                transformOrigin || {
                    vertical: 'top',
                    horizontal: 'right',
                }
            }
            PaperProps={PaperProps}
            disableScrollLock={disableScrollLock}
            hideBackdrop={hideBackdrop}
            transitionDuration={transitionDuration}
        >
            <div ref={wrapperRef} className={classNames(popoverStyle.content, className)}>
                {header ? <span className={popoverStyle.header}>{header}</span> : null}
                <div className={popoverStyle.content}>{children}</div>
            </div>
        </MuiPopover>
    );
};

Popover.propTypes = {
    children: PropTypes.node.isRequired,
    showPopover: PropTypes.bool,
    anchorEl: PropTypes.objectOf(PropTypes.object),
    header: PropTypes.string,
    wrapperRef: PropTypes.object,
    className: PropTypes.string,
    rootClassName: PropTypes.string,
    anchorOrigin: PropTypes.shape({
        vertical: PropTypes.string,
        horizontal: PropTypes.string,
    }),
    transformOrigin: PropTypes.shape({
        vertical: PropTypes.string,
        horizontal: PropTypes.string,
    }),
    PaperProps: PropTypes.object,
    disableScrollLock: PropTypes.bool,
    hideBackdrop: PropTypes.bool,
    transitionDuration: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.oneOf(['auto']),
        PropTypes.shape({ enter: PropTypes.number, exit: PropTypes.number }),
    ]),
    onClose: PropTypes.func,
};

export default Popover;
